import React, { useEffect, useState } from 'react'
import { Grid, Typography, TextField, Button, styled } from '@mui/material'
import api from '../../utils/api'
import TeacherInfo from './TeacherInfo'
import { Pagination, Alert } from '@mui/material';
import Spinner from '../../components/ui/Spinner'
import SearchIcon from '@mui/icons-material/Search'

const StyledButton = styled(Button)({
  color: 'white'
})

const TeachersListScreen2 = () => {
  const [teachers, setTeachers] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [page, setPage] = useState(1)
  const [searchKey, setSearchKey] = useState('')
  const [loading, setLoading] = useState(false)
  const [searchKeyNotFound, setSearchKeyNotFound] = useState('')

  const fetchPagesOfTeachers = async () => {
    setLoading(true)
    const res = await api.get('/teachers/page/v2')
    setTeachers(res.data.teachers)
    setTotalPages(res.data.totalPages)
    setLoading(false)
  }

  const handleChangePage = async (event, value) => {
    setLoading(true)
    const res = await api.get(`/teachers/page/v2?page=${value}`)
    setTeachers(res.data.teachers)
    setTotalPages(res.data.totalPages)
    setPage(value)
    setLoading(false)
  }

  useEffect(() => {
    fetchPagesOfTeachers()
  }, [])

  const handleSubmitSearch = async (e) => {
    e.preventDefault()

    setLoading(true)
    const res = await api.get(`/teachers/page/v2?page=1&searchKey=${searchKey}`)
    setTeachers(res.data.teachers)
    setTotalPages(res.data.totalPages)

    if (res.data.teachers.length === 0) {
      const currentSearchKey = searchKey

      setSearchKeyNotFound(currentSearchKey)
    }

    setLoading(false)
  }

  const handleOnChange = (e) => {
    setSearchKey(e.target.value)
  }

  return (
    <Grid
      container
      className="container"
      alignItems="center"
      justifyContent="center"
      direction="column"
      spacing={2}
      style={{ width: '100%', margin: '0' }}
    >
      <Grid item>
        <Typography
          variant="h4"
          style={{
            textTransform: 'uppercase',
            fontWeight: '500',
            textAlign: 'center',
          }}
        >
          Danh sách giáo viên
        </Typography>
      </Grid>

      <Grid item>
        <form onSubmit={handleSubmitSearch}>
          <Grid container justifyContent='center' alignItems='center' spacing={1}>
            <Grid item>
              <TextField name='search' variant='outlined' label='Tìm kiếm bằng tên' fullWidth style={{ backgroundColor: 'white' }} value={searchKey} onChange={handleOnChange} />
            </Grid>

            <Grid item>
              <StyledButton color='primary' variant='contained' type='submit'><SearchIcon />&nbsp;Tìm kiếm</StyledButton>
            </Grid>
          </Grid>
        </form>
      </Grid>

      {(teachers.length === 0 && searchKeyNotFound) && <Grid item>
        <Alert severity='error' style={{ fontSize: '1em', fontWeight: '600' }}>{`Không tìm thấy giáo viên nào tên "${searchKeyNotFound}"`}</Alert>
      </Grid>}

      <Grid item container direction="column">
        {loading ? <Spinner /> : teachers.map(teacher => <Grid item><TeacherInfo teacher={teacher} key={teacher._id} /></Grid>)}
      </Grid>

      <Grid item>
        <Pagination count={totalPages} page={page} onChange={handleChangePage} color='primary' />
      </Grid>
    </Grid>
  );
}

export default TeachersListScreen2